import classNames from 'classnames'
import {gsap} from 'gsap'
import * as React from 'react'

import {tailwindConfig} from '@/common/utils'
import {NAVIGATION_HEIGHT, TOP_NAVIGATION_HEIGHT} from '@/components/Navigation/Navigation'

export const TRANSITION_DURATION = 0.4

const rounded = 'rounded-t-[theme(spacing.10)]'

const LayoutWrapper = ({children, category}) => {
  const wrapperRef = React.useRef()

  React.useEffect(() => {
    const wrapper = wrapperRef.current

    if (wrapper) {
      const mm = gsap.matchMedia()
      mm.add(`(min-width: ${tailwindConfig.theme.screens['lg']})`, () => {
        gsap.fromTo(
          wrapper,
          {scaleX: 1, '--round': '0px'},
          {
            scaleX: 0.9,
            '--round': '48px',
            scrollTrigger: {
              trigger: wrapper,
              start: 'bottom 90%',
              scrub: true,
            },
          }
        )
      })

      return () => mm.revert()
    }
  }, [])
  return (
    <div className=' bg-violet-600' style={{paddingTop: TOP_NAVIGATION_HEIGHT}}>
      <div ref={wrapperRef} className='clipPath relative'>
        <div
          className={classNames(
            rounded,
            'absolute left-0 h-full w-full rounded-3xl bg-white lg:rounded-none ',
            {
              'bg-yellow-200': category === 'livres-blancs',
              'event bg-[radial-gradient(104%_2%_at_50%_0%,rgba(227,243,32,0.4)_2%,rgba(227,243,32,0)_50%)]':
                category === 'evenements' || category === 'etudes-de-cas',
              'bg-[radial-gradient(58%_2%_at_50%_0%,rgba(227,243,32,0.4)_20%,rgba(227,243,32,0)_66%)] md:bg-[radial-gradient(58%_3%_at_50%_0%,rgba(227,243,32,0.4)_2%,rgba(227,243,32,0)_70%)] lg:bg-[radial-gradient(48%_6%_at_50%_0%,rgba(227,243,32,0.4)_20%,rgba(227,243,32,0)_80%)]':
                category !== 'evenements' &&
                category !== 'etudes-de-cas' &&
                category !== 'livres-blancs',
            }
          )}
        />
        <div className={rounded} style={{paddingTop: NAVIGATION_HEIGHT}}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default LayoutWrapper
